const Ranking = ({ users = [] }) => {
    const filteredUsers = users.filter(user => user.name !== "base-user");
    return (
        <section className="w-[504px] h-[432px] bg-white py-4 rounded-2xl flex flex-col">
            <h3 className="text-center text-[#282828] font-semibold text-sm h-5 mb-5">Ranking de desempeño</h3>
            <div className=" w-full text-white py-2 px-[44px] bg-3366FF flex h-8 gap-2 items-center">
                <p className=" text-white text-xs font-bold leading-5 w-14 text-center ">Posición</p>
                <p className=" text-white text-xs font-bold leading-5 flex-1 text-center">Nombre</p>
                <p className=" text-white text-xs font-bold leading-5 w-14 text-center ">Región</p>
                <p className=" text-white text-xs font-bold leading-5 w-14 text-center   ">Errores</p>
                <p className=" text-white text-xs font-bold leading-5 w-14 text-center  ">Tiempo</p>
            </div>
            <ul className="w-full text-black  p-0  flex-1  overflow-scroll scroll-m-0 ranking ">
                {filteredUsers.map((user, key) => <li key={key} className=" text-[#454545] text-[10px] font-normal leading-[22px] w-full flex gap-2  px-[44px] items-center py-2">
                    <div className="w-14 text-center">
                        <p>{key + 1}°</p>
                    </div>
                    <div className="flex-1 text-center px-4">
                        <p className="text-left">{user.name}</p>
                    </div>
                    <div className="w-14 text-center  px-4">
                        <p className="text-left">{String(user.group.name).toUpperCase()}</p>
                    </div>
                    <div className="w-14 text-center ">
                        <p>{user.responses.filter(item => item.answer === "False").length}</p>
                    </div>
                    <div className="w-14  text-center">
                        <p className="text-right">{(user.time / 60).toFixed(1)} min.</p>
                    </div>
                </li>)}

            </ul>
        </section>
    );
}

export default Ranking;